<template>
  <div class="subscription-order-container">
    <el-card class="order-card">
      <div class="order-header">
        <h2>Subscribe to {{ program.name }}</h2>
      </div>
      
      <div class="program-details" v-if="program">
        <div class="program-info">
          <p class="description">{{ program.description }}</p>
          <div class="price-info">
            <span class="price">${{ program.usd_price }}</span>
            <span class="period">/ {{ program.recurring_period.slice(0, -2) }}</span>
          </div>
        </div>

        <el-form :model="orderForm" :rules="rules" ref="orderForm" label-width="120px" class="order-form">
          

          

          <div class="order-summary">
            <div class="summary-row">
              <span>Subscription Fee for the first {{ program.recurring_period.slice(0, -2) }}</span>
              <span>${{ program.usd_price }}</span>
            </div>
            <div class="summary-row total">
              <span>Total to pay now </span>
              <span>${{ program.usd_price }}</span>
            </div>
          </div>
          <div class="subscription-note">Date of Subscription: {{ new Date().toLocaleDateString() }}</div>
          <div class="subscription-note">Next billing date: {{ new Date(new Date().setMonth(new Date().getMonth() + 1)).toLocaleDateString() }}</div>
          <div class="subscription-note">You can cancel your subscription at any time</div>
          <div class="form-actions">
            <el-button @click="$router.go(-1)">Cancel</el-button>
            <el-button type="primary" @click="submitOrder" :loading="submitting">
              Subscribe Now
            </el-button>
          </div>
        </el-form>
      </div>

      <el-skeleton :rows="3" animated v-else-if="loading" />
      <div v-else class="empty-state">
        <p>Program not found</p>
        <el-button type="primary" @click="$router.go(-1)">Go Back</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'

export default {
  name: 'SubscriptionOrder',
  data() {
    return {
      program: null,
      loading: true,
      submitting: false,
      orderForm: {
        payment_method: '',
        auto_renew: true
      },
      rules: {
        payment_method: [
          { required: true, message: 'Please select a payment method', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.fetchProgram()
  },
  methods: {
    async fetchProgram() {
      this.loading = true
      try {
        const response = await postRequest('getUserSubscriptionProgram', {
          id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.program = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to load program details')
        }
      } catch (error) {
        console.error('Error fetching program:', error)
        this.$message.error('Failed to load program details')
      } finally {
        this.loading = false
      }
    },
    async submitOrder() {
      this.$refs.orderForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          // TODO: Implement subscription order submission
          const response = await postRequest('createSubscriptionOrder', {
            program_id: (this.program._id.$oid || this.program._id.$id),
            user_id: this.$store.state.user_id,
            payment_method: this.orderForm.payment_method,
            auto_renew: this.orderForm.auto_renew
          })
          if(response.data.code == 0){
            this.$message.success('Subscription order placed successfully')
            this.$router.push({
                path:'/pay',
                query:{
                  order_id:(response.data.data._id.$oid || response.data.data._id.$id),
                  order_type:"subscription"
                }
            })
            // this.$router.push('/my-subscriptions')
          }else {
            this.$message.warning(response.data.msg)
          }
        } catch (error) {
          console.error('Error submitting order:', error)
          this.$message.error('Failed to place subscription order')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.subscription-order-container {
  width: 70%;
  margin: 40px auto;
  padding: 0 20px;
}

.order-card {
  padding: 30px;
}

.order-header {
  margin-bottom: 30px;
  text-align: center;
}

.order-header h2 {
  margin: 0;
  color: #303133;
}

.program-details {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.program-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.description {
  color: #606266;
  margin-bottom: 15px;
  line-height: 1.5;
}

.price-info {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.period {
  color: #909399;
}

.order-form {
  margin-top: 20px;
}

.order-summary {
  margin: 30px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #606266;
}

.summary-row.total {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
  font-weight: bold;
  color: #303133;
  font-size: 18px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #909399;
}
</style> 